import React from 'react';
import { Text } from "@nextui-org/react";
import Layout from '../../components/layout/purchasing';

export default function Overview() {
  return (
    <Text h1>Overview</Text>
  );
}
